import { DeploymentCompany } from "#models/env"
import { FeatureFlagsSchema } from "#models/FeatureFlags"
import { S, TaggedRequestFor } from "./lib.ts"

// codegen:start {preset: meta, sourcePrefix: src/resources/ }
const Req = TaggedRequestFor("FeatureFlags")
// codegen:end

export class Get extends Req.Query<Get>()("Get", {
  company: S.optionalKey(DeploymentCompany)
}, {
  allowAnonymous: true,
  success: S.Struct({
    featureFlags: FeatureFlagsSchema
  })
}) {}
